import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'igo-confirm-dialog',
  template: require('./confirm-dialog.component.html'),
})
export class ConfirmDialogComponent {

  public confirmMessage: string;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>) {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/confirm-dialog/confirm-dialog.component.ts